import { useCallback, useEffect, useState } from "react";
import Label from "../../../../components/FormComponents/Label";
import Toggle from "../../../../components/FormComponents/Toggle";
import { useAppBlocksContext } from "../../../../context/AppBlocksContext";
import useZTheme from "../../../../hooks/useZTheme";
import { elementConfig } from "../../../../utils/Config/DefaultConfig/elementConfig";
import { getSidebarElementsForPositionRecordview } from "../../../../utils/sidebarElementList";
import PositionScreenWithEdit from "../../../FlexibleLayout/PositionScreenWithEdit";
import {
  findItemById,
  getOffset,
  getPositionedElementConfig,
  getScreenWidth,
  updateOnlyElementConfigInLayout
} from "../../../FlexibleLayout/utils";
import {
  EditPrefilterWithSummary,
  EditPreSortWithSummary,
  RVOnRowAction
} from "../Desktop/NewDesktopRecordviewRenderer";
import { RVCAtalogViewForPostioned, RvElementBar } from "../Desktop/PositionedDesktopRecordview";
import { HiddenColumns } from "./MobileRecordEditSection";
import MobileRVPageActionsHandler from "./MobileRVPageActionsHandler";
const PositionedMobileRecordview = () => {
  useZTheme("mobile");
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [selectedItem, setSelectedItem] = useState(null);
  const initialStateOfCatalogPlayground = {
    show: false,
    tableElementId: ""
  };
  const [isCatalogPlaygroundOpen, setIsCatalogPlaygroundOpen] = useState(initialStateOfCatalogPlayground);
  const [layoutConfig, setLayoutConfig] = useState([]);
  const [cardDimentions, setCardDimentions] = useState({
    width: 0
  });

  const {
    applicationBlockData,
    recordsviewLayout,
    layoutConfig: appBlockLayoutConfig,
    setLayoutConfig: setAppBlockLayoutConfig
  } = useAppBlocksContext();
  // const [screenLayoutInfo, setScreenLayoutInfo] = useState({
  //   showGrid: true,
  //   showTree: false,
  //   showTemplate: false,
  //   screenMode: "editable",
  //   scaleFactor: 1,
  //   gridSize: applicationBlockData.position_block_metadata?.grid_size || 4
  // });
  // const { position_block_config } = applicationBlockData;

  const openCatalogEditPlayground = (id) => {
    const tableElement = findItemById(appBlockLayoutConfig, id);
    if (!tableElement) return;
    if (tableElement.config.type === "map") {
      setCardDimentions({ width: tableElement.config.card_width });
      setLayoutConfig(tableElement.config.card.layout);
      setIsCatalogPlaygroundOpen({ show: true, tableElementId: id, columnIndex: null });
      return;
    }
    if (tableElement.config.type === "rv_table") {
      const gapCount = tableElement.config.catalog.cards_per_row - 1;
      const totalGap = gapCount * parseInt(tableElement.config.catalog.gap_between_cards);
      const totalWidth = parseInt(tableElement.style.width) - totalGap;
      const cardWidth = Math.floor(totalWidth / tableElement.config.catalog.cards_per_row);

      setCardDimentions({ width: cardWidth });
      setLayoutConfig(tableElement.config.catalog.layout);
      setIsCatalogPlaygroundOpen({ show: true, tableElementId: id });
    }
  };

  const closeCatalogEditPlayground = () => {
    setIsCatalogPlaygroundOpen(initialStateOfCatalogPlayground);
  };

  const { pre_filters, default_sort, hidden_columns, on_row_action } = recordsviewLayout || {};
  const [toggleRvBlock, setToggleRvBlock] = useState({
    preFilters: !!pre_filters?.length,
    preSort: !!default_sort?.length,
    hiddenColumns: !!hidden_columns?.length,
    onRowClickJob: !!on_row_action?.job_id
  });

  const handleChangeToggleBlock = (stateName, value) => {
    setToggleRvBlock({ ...toggleRvBlock, [stateName]: value });
  };

  const handleChangeLayoutConfig = (newLayout) => {
    setAppBlockLayoutConfig(newLayout);
  };
  const handleDragStart = useCallback((e, item) => {
    const { type } = item;
    let newConfig = getPositionedElementConfig(type, "mobile");
    if (newConfig.type === "element") {
      newConfig.config = elementConfig[type];
      if (newConfig.config.type === "rv_table") {
        newConfig.config.layout_type = "catalog_view";
      }
    }
    const offset = getOffset(e);
    setDraggedItem(newConfig);
    setDragOffset(offset);
  }, []);

  const handleOpenCatalogView = (item, otherInfo) => {
    const { config, id } = item;
    if (config && config.type === "rv_table" && otherInfo && otherInfo.type === "edit_catalog") {
      openCatalogEditPlayground(id);
      return;
    }
    if (otherInfo && otherInfo.type === "edit_map_card") {
      openCatalogEditPlayground(id);
      return;
    }
  };

  useEffect(() => {
    const tableElement = findItemById(appBlockLayoutConfig, isCatalogPlaygroundOpen.tableElementId);

    if (!tableElement) return;
    const tableConfig = JSON.parse(JSON.stringify(tableElement.config));
    if (tableElement.config.type === "map") {
      tableConfig.card = tableConfig.card || {};
      tableConfig.card.layout = layoutConfig;
      const newLayoutConfig = updateOnlyElementConfigInLayout(
        appBlockLayoutConfig,
        isCatalogPlaygroundOpen.tableElementId,
        tableConfig
      );
      handleChangeLayoutConfig(newLayoutConfig);
      return;
    }
    if (tableElement.config.type === "rv_table") {
      tableConfig.catalog.layout = layoutConfig; // Now, layoutConfig is updated

      const newLayoutConfig = updateOnlyElementConfigInLayout(
        appBlockLayoutConfig,
        isCatalogPlaygroundOpen.tableElementId,
        tableConfig
      );

      handleChangeLayoutConfig(newLayoutConfig);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [layoutConfig]); // Runs when layoutConfig changes

  if (isCatalogPlaygroundOpen.show) {
    return (
      <>
        <RVCAtalogViewForPostioned
          width={cardDimentions.width}
          height={"100%"}
          layoutConfig={layoutConfig}
          setLayoutConfig={setLayoutConfig}
          device={"mobile"}
          tableId={applicationBlockData.config.layout.table_id}
          tableType={applicationBlockData.table_type}
          elements={[applicationBlockData]}
          onClose={closeCatalogEditPlayground}
        />
      </>
    );
  }
  // const getScreenWidth = () => {
  //   const { grid_size, total_grid } = applicationBlockData.position_block_metadata || {};
  //   if (grid_size && total_grid) {
  //     return grid_size * total_grid;
  //   }
  //   return 0;
  // };

  const filteredSidebarElements = getSidebarElementsForPositionRecordview().map((group) => ({
    ...group,
    items: group.items.filter(
      (item) =>
        item.type !== "rv_action_button" &&
        item.type !== "rv_action_dropdown" &&
        item.type !== "rv_table_catalog_toggler"
    )
  }));

  return (
    <div className="detailsView_outer_body">
      <div className="screen-center-wrapper">
        <MobileRVPageActionsHandler />
        <div className="page-action-bar-top space_between">
          <ToggleRVConfigPanel handleChangeToggleBlock={handleChangeToggleBlock} toggleRvBlock={toggleRvBlock} />
          <div className="d_flex gap_3">
            {/* <PositionScreenActionBar
              screenLayoutInfo={screenLayoutInfo}
              setScreenLayoutInfo={setScreenLayoutInfo}
              device={"mobile"}
            /> */}
          </div>
        </div>

        <div className="position-screen-center-page">
          <>
            <RVConfigPanel showPanel={toggleRvBlock} />

            <PositionScreenWithEdit
              layoutConfig={appBlockLayoutConfig || []}
              setLayoutConfig={setAppBlockLayoutConfig}
              draggedItem={draggedItem}
              setDragOffset={setDragOffset}
              setDraggedItem={setDraggedItem}
              dragOffset={dragOffset}
              // type={screenLayoutInfo.screenMode}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              // gridSize={screenLayoutInfo.gridSize}
              screenWidth={getScreenWidth({
                device: applicationBlockData.device,
                metadata: applicationBlockData.position_block_metadata
              })}
              // showGrid={screenLayoutInfo.showGrid}
              // showTree={screenLayoutInfo.showTree}
              // setShowTree={() => setScreenLayoutInfo({ ...screenLayoutInfo, showTree: false })}
              tableId={applicationBlockData.config.layout.table_id}
              tableType={applicationBlockData.table_type}
              device={applicationBlockData.device}
              buttonElements={[applicationBlockData]}
              onClick={handleOpenCatalogView}
              jobPlaces="screen"
            />
          </>
        </div>
        {/* <BuilderModal
          isOpen={screenLayoutInfo.showTemplate}
          onClose={() => setScreenLayoutInfo({ ...screenLayoutInfo, showTemplate: false })}
          modalName="Templates"
          customStyleClsName="template_modal_fullsize"
          bodyStyle={{ minHeight: "100vh", overflow: "auto" }}
        >
          <PositionedTemplateList />
        </BuilderModal> */}
      </div>
      <div className="rightsidebar" style={{ padding: "18px" }}>
        <RvElementBar data={filteredSidebarElements} onDragStart={handleDragStart} />
      </div>
    </div>
  );
};

const RVConfigPanel = ({ showPanel }) => {
  const { applicationBlockData, recordsviewLayout, setRecordsviewLayout } = useAppBlocksContext();
  const handleChangePrefilters = (type, data) => {
    if (type === "prefilter") {
      setRecordsviewLayout({
        ...recordsviewLayout,
        pre_filters: data.prefilter,
        prefilters_joined_by: data.prefilters_joined_by
      });
    }
    if (type === "owner_pre_filters") {
      setRecordsviewLayout({ ...recordsviewLayout, owner_pre_filters: data });
    }
  };
  const handleChangeDefaultSort = (data) => {
    setRecordsviewLayout({ ...recordsviewLayout, default_sort: data });
  };
  const handleChangeHiddenColumn = (column) => {
    setRecordsviewLayout({ ...recordsviewLayout, hidden_columns: column });
  };
  const handleChangeOnRowAction = (data) => {
    setRecordsviewLayout({ ...recordsviewLayout, on_row_action: data });
  };
  return (
    <div className="rv_prefilter_sort_container">
      {showPanel.preFilters && (
        <div className="position_relative">
          <Label
            className="position_absolute font_weight_semibold"
            style={{
              top: "-12px",
              left: "20px",
              padding: "4px",
              display: recordsviewLayout?.pre_filters?.length > 0 ? "none" : "block"
            }}
          >
            Pre Filters
          </Label>
          <EditPrefilterWithSummary
            prefiltersWithFormula={{
              prefilter: recordsviewLayout?.pre_filters || [],
              prefilters_joined_by: recordsviewLayout?.prefilters_joined_by || "",
              owner_pre_filters: recordsviewLayout?.owner_pre_filters || {}
            }}
            handleChange={handleChangePrefilters}
            tableId={applicationBlockData.config.layout.table_id || ""}
            activityId={applicationBlockData?.config?.layout?.activity_id || ""}
            tableType={applicationBlockData?.table_type || ""}
          />
        </div>
      )}
      {showPanel.preSort && (
        <div className="position_relative">
          <Label
            className="position_absolute font_weight_semibold"
            style={{
              top: "-12px",
              left: "20px",
              padding: "4px",
              display: recordsviewLayout?.default_sort?.length > 0 ? "none" : "block"
            }}
          >
            Pre Sort
          </Label>
          <EditPreSortWithSummary
            defaultSort={recordsviewLayout?.default_sort || []}
            handleChangeDefaultSort={handleChangeDefaultSort}
            tableId={applicationBlockData.config.layout.table_id || ""}
            tableType={applicationBlockData?.table_type || ""}
            activityId={applicationBlockData?.config?.layout?.activity_id || ""}
          />
        </div>
      )}
      {showPanel.onRowClickJob && (
        <div className="position_relative">
          <Label
            className="position_absolute font_weight_semibold"
            style={{ top: "-12px", left: "20px", padding: "4px" }}
          >
            On Row Job
          </Label>
          <RVOnRowAction
            job={recordsviewLayout?.on_row_action || null}
            onChange={handleChangeOnRowAction}
            tableId={applicationBlockData.config.layout.table_id || ""}
            tableType={applicationBlockData?.table_type || ""}
            device={"mobile"}
          />
        </div>
      )}
      {showPanel.hiddenColumns && (
        <div className="p_3">
          <HiddenColumns
            columns={recordsviewLayout.hidden_columns || []}
            handleChange={handleChangeHiddenColumn}
            tableId={recordsviewLayout.table_id || ""}
          />
        </div>
      )}
    </div>
  );
};

const ToggleRVConfigPanel = ({ toggleRvBlock, handleChangeToggleBlock }) => {
  //   const { blockData } = useAppBlocksContext();
  const { applicationBlockData } = useAppBlocksContext();
  const { pre_filters, default_sort, hidden_columns, on_row_action } = applicationBlockData?.config?.layout || {};
  const listOfBlocks = [
    { name: "Pre Filters", state: "preFilters", count: pre_filters?.length || 0 },
    { name: "Pre Sort", state: "preSort", count: default_sort?.length || 0 },
    { name: "Hidden Columns", state: "hiddenColumns", count: hidden_columns?.length || 0 },
    { name: "On Row Job", state: "onRowClickJob", count: on_row_action?.job_id ? 1 : 0 }
  ];
  return (
    <div className="d_flex gap_4 align_center">
      {listOfBlocks.map(({ name, state, count }) => (
        <div className="d_flex gap_2 align_center" key={name}>
          <div className="d_flex gap_1 justify_center align_center">
            <Label>{name}</Label>
            {count !== 0 && (
              <span
                className="d_flex gap_1 justify_center align_center"
                style={{
                  width: "20px",
                  height: "20px",
                  borderRadius: "100%",
                  backgroundColor: "var(--builder-active)",
                  border: "1px solid var(--builder-border)"
                }}
              >
                {count}
              </span>
            )}
          </div>
          <Toggle value={toggleRvBlock[state]} onChange={(e) => handleChangeToggleBlock(state, e.target.checked)} />
        </div>
      ))}
    </div>
  );
};

export default PositionedMobileRecordview;
